/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Modal } from "antd";
import moment from "moment";
import React from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { LicenseDetail } from "src/models/enterprise";

export default React.memo(
  (props: {
    isView: boolean;
    viewDetail: LicenseDetail;
    onViewClose: () => void;
  }) => {
    const { isView, viewDetail, onViewClose } = props;
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();

    const detailCss = css`
      display: flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.85);
      background-color: rgb(247, 249, 252);
      padding: 5px 13px;
      min-height: 32px;
      max-width: 670px;
      word-wrap: break-word;
      word-break: break-word;
    `;
    return (
      <div css={css``}>
        <Modal
          title={formatMessage(messageIds.company.licenseDetail)}
          visible={isView}
          onCancel={onViewClose}
          footer={""}
          css={css`
            .ant-modal-header {
              border-bottom: none;
            }
          `}
        >
          <Form
            form={form}
            layout="vertical"
            css={css`
              max-height: 80vh;
              overflow-y: auto;
              overflow-x: hidden;
            `}
          >
            <Form.Item label={formatMessage(messageIds.company.licenseNumber)}>
              <div css={detailCss}>{viewDetail?.id}</div>
            </Form.Item>
            <Form.Item
              label={formatMessage(messageIds.license.common.userImported)}
            >
              <div css={detailCss}>{viewDetail?.name}</div>
            </Form.Item>
            <Form.Item
              label={formatMessage(messageIds.license.common.requestAt)}
            >
              <div css={detailCss}>
                {moment(viewDetail?.requestAt).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            </Form.Item>
            <Form.Item
              label={formatMessage(messageIds.license.common.createdAt)}
            >
              <div css={detailCss}>
                {moment(viewDetail?.createdAt).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            </Form.Item>
            <Form.Item label={formatMessage(messageIds.license.common.fromTo)}>
              <div css={detailCss}>
                {moment(viewDetail?.validFrom).format("YYYY-MM-DD HH:mm:ss")} ~{" "}
                {moment(viewDetail?.validTo).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            </Form.Item>
            <Form.Item
              label={formatMessage(messageIds.license.common.machineKey)}
            >
              <div css={detailCss}>{viewDetail?.machineKey}</div>
            </Form.Item>
            {viewDetail?.quota?.map((item) =>
              item.name === "Console" || item.name === "App" ? (
                ""
              ) : (
                <Form.Item
                  key={`${item.name}_${item.sku}`}
                  label={
                    item.name === "Studio"
                      ? item.sku === "Enterprise"
                        ? formatMessage(messageIds.license.console.numStudio)
                        : formatMessage(
                            messageIds.license.console.numFloatingStudio
                          )
                      : item.name === "Robot"
                      ? item.sku === "Enterprise_basic"
                        ? formatMessage(
                            messageIds.license.console.numBasicRobot
                          )
                        : item.sku === "Enterprise_pro"
                        ? formatMessage(
                            messageIds.license.console.numPremiumRobot
                          )
                        : formatMessage(
                            messageIds.license.console.numFloatingRobot
                          )
                      : item.name === "DocumentUnderstanding"
                      ? item.sku === "PdfImage"
                        ? formatMessage(messageIds.license.console.numPdfImage)
                        : formatMessage(messageIds.license.console.numPdfText)
                      : item.name === "ViCode"
                      ? formatMessage(messageIds.license.console.numVicode)
                      : ""
                  }
                >
                  <div css={detailCss}>{item.count}</div>
                </Form.Item>
              )
            )}
          </Form>
          <div
            css={css`
              text-align: right;
              margin-top: 20px;
            `}
          >
            <Button
              type="primary"
              css={css`
                height: 32px;
                min-width: 88px;
                border-radius: 4px;
              `}
              onClick={onViewClose}
            >
              {formatMessage(messageIds.common.confirm)}
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
);
